import { render } from "./DetailViewFr.vue?vue&type=template&id=9793999a"
import script from "./DetailViewFr.vue?vue&type=script&lang=js"
export * from "./DetailViewFr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__